import React, {useEffect, useRef} from 'react';
import {getDictionaryString} from '@dazn/lp-web/src/utils/dictionary';
import styles from '@dazn/lp-web/src/components/SponsorShipAds/sponsor-ship-logo.module.css';
import {loadSponsorShipLogoScript} from '@dazn/lp-web/src/components/SponsorShipAds/loadSponsorShipLogoScript';

interface ISponsorshipProps {
    slotPath: string;
    index: number;
}

const testIds = {
    LABEL: 'SPONSORSHIP_LABEL',
    SPONSORSHIP_LOGO: 'SPONSORSHIP_LOGO'
};

const SPONSORSHIP_LOGO_CONSTANTS = {
    SPONSORSHIP_LOGO_PRESENTED_BY: 'web_nfl_presented_by',
    MAIN_DIV_ID: 'main-gpt-ad-1692856420324-0',
    LOGO_DIV_ID: 'div-gpt-ad-1692856420324-0'
};

export const SponsorshipAds: React.FC<ISponsorshipProps> = ({
    index,
    slotPath
}) => {
    const adTile = getDictionaryString(
        SPONSORSHIP_LOGO_CONSTANTS.SPONSORSHIP_LOGO_PRESENTED_BY
    );
    const mainDivRef = useRef(null);

    useEffect(() => {
        if (!slotPath || !mainDivRef.current) return;

        loadSponsorShipLogoScript(
            mainDivRef,
            SPONSORSHIP_LOGO_CONSTANTS.LOGO_DIV_ID,
            slotPath
        );
    }, [index, slotPath, mainDivRef]);

    if (!slotPath) return null;

    return (
        <div
            className={styles.sponsoredLogoMainDiv}
            id={SPONSORSHIP_LOGO_CONSTANTS.MAIN_DIV_ID}
            ref={mainDivRef}
        >
            <div className={styles.sponsoredTitle} data-test-id={testIds.LABEL}>
                {adTile}
            </div>
            <div
                className={styles.sponsoredLogo}
                data-test-id={testIds.SPONSORSHIP_LOGO}
                id={SPONSORSHIP_LOGO_CONSTANTS.LOGO_DIV_ID}
            />
        </div>
    );
};
